// src/components/LoadingSpinner.js
import React from 'react';
import './styles/LoadingSpinner.css'; // Archivo CSS para estilos opcionales

const LoadingSpinner = ({ text = "Cargando..." }) => {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>{text}</p>
    </div>
  );
};

export default LoadingSpinner;